module.exports = __webpack_public_path__ + "static/media/MoveToAssetGallery.1b1ce06f.svg";